import MainMenuBlock from '../mainMenuBlock/MainMenuBlock';

export default MainMenuBlock.extend(
    {

        template: require('./blockAutocomplete.hbs'),
        componentClass: 'blockAutocomplete',
        constructor(options) {
            this.classPrefix = '.blockAutocomplete-';
            MainMenuBlock.prototype.constructor.call(this, options);

        },

        createConfigSubcomponents() {
            this.components = {
                Autocomplete: {
                    position: 'autocomplete',
                    componentConstructorClass: 'Autocomplete',
                    identifier: 'Autocomplete',
                    properties: {
                        providers: {
                            GPlacesAutocomplete: {
                                icons: ['transit_station', 'bus_station', 'train_station'],
                                minLength: 3,
                                maxResults: 5
                            },
                            ListHotelsProvider: {
                                minLength: 1,
                                maxResults: 5
                            }
                        }
                    },
                    resultsPanel: this.$el.find('.blockAutocomplete-result'),
                    errorPanel: this.$el.find('.blockAutocomplete-no-result-container')
                }
            };
            if (!this.widget.isMobileVersion) {
                this.components.HotelDetailPanel = {
                    position: 'hotel-detail-panel',
                    componentConstructorClass: 'HotelDetailPanel',
                    identifier: 'HotelDetailPanel',
                    parent: this
                };
            }
        },

        initialize(options) {
            this.templateConfig.resultHeight = this.widget.getHeight();
            this.templateConfig.isMobileVersion = this.widget.isMobileVersion;
            MainMenuBlock.prototype.initialize.call(this, options);
            if (!this.widget.isMobileVersion) {
                this.listenTo(this.bus, 'SHOW_RESULTS_LIST', () => {
                    this.$el.find('.blockAutocomplete-hotel-detail-panel').hide();
                });
                this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', () => {
                    this.$el.find('.blockAutocomplete-hotel-detail-panel').show();

                });
                this.listenTo(this.bus, 'SELECT_RESULT', () => {
                    if (!this.components.HotelDetailPanel.onClose) {
                        this.$el.find('.blockAutocomplete-hotel-detail-panel').show();
                        this.$el.find('.lmm-main-box-hotel-detail-panel').show();
                    }
                });
            }

        },

        events: {},
    });



// WEBPACK FOOTER //
// ./src/components/blockAutocomplete/BlockAutocomplete.js